import { NumberBox, TextBox } from "devextreme-react";
import DataGrid, {
    Column,
    Editing,
    MasterDetail,
    Selection
} from "devextreme-react/data-grid";
import DateBox from "devextreme-react/date-box";
import moment from 'moment';
import { useEffect, useRef, useState } from "react";
import { mucPhaiThuApi } from "../../api/mucPhaiThuApi";
import { mucPhaiThuChiTietApi } from "../../api/mucPhaiThuChiTietApi";
import { thuPhiApi } from "../../api/thuPhiApi";
import { Button } from "../../components/buttons";
import { FormGroupInline } from "../../components/form-group";
import { DefaultPopup } from "../../components/modal";
import TagboxHinhThucNopBom from "../../components/tagbox-hinh-thuc-nop-bom";
import { showNotify } from "../../helpers/toast";
import { IMucPhaiThuHoanPhiRequest } from "../../models/request/muc-phai-thu/IMucPhaiThuAddHoanPhiRequest";
import { sf_mucphaithu_viewmodel } from "../../models/response/thu-phi/sf_mucphaithu";
import { sf_mucphaithu_chitiet_viewmodel } from "../../models/response/thu-phi/sf_mucphaithu_chitiet";
import styles from "./HoanPhiHocSinhPage.module.css";
import HoanPhiDaTao from "./hoan-phi-da-tao";

interface IHoanPhiHocSinhPageProps {
    onClose: () => void;
    sf_mucphaithu_id: number;
}
const HoanPhiHocSinhPage = (props: IHoanPhiHocSinhPageProps) => {
    const [hinhThucNopBomIds, setHinhThucNopBomIds] = useState<number[]>([]);
    const [mucPhaiThu, setMucPhaiThu] = useState<sf_mucphaithu_viewmodel>();
    const [mucPhaiThuHoanPhis, setMucPhaiThuHoanPhis] = useState<
        sf_mucphaithu_viewmodel[]
    >([]);
    const [mucPhaiThuChiTiets, setMucPhaiThuChiTiets] = useState<
        sf_mucphaithu_chitiet_viewmodel[]
    >([]);
    const [mucPhaiThuChiTietSelectedIds, setMucPhaiThuChiTietSelectedIds] = useState<number[]>([]);
    const [mucPhaiThuMienGiams, setMucPhaiThuMienGiams] = useState([]);
    const [mucPhaiThuChiTietMienGiams, setMucPhaiThuChiTietMienGiams] = useState([]);
    const [
        hoanPhiSelectedMucPhaiThuChiTiets,
        setHoanPhiSelectedMucPhaiThuChiTiets,
    ] = useState<any[]>([]);
    const [ngaythu, set_ngaythu] = useState<any>(moment().format('YYYY-MM-DD'));
    const [noiDungHoanPhi, setNoiDungHoanPhi] = useState<string>('');

    useEffect(() => {
        setMucPhaiThuChiTietSelectedIds(
            hoanPhiSelectedMucPhaiThuChiTiets
                .filter((x) => x.tong_hoan_tra > 0)
                .map((x: any) => x.sf_mucphaithu_chitiet_id)
        );
    }, [hoanPhiSelectedMucPhaiThuChiTiets]);
    const [isSaving, setIsSaving] = useState<boolean>(false);

    const grid = useRef<any>();
    // console.log({
    //     mucPhaiThu,
    //     mucPhaiThuChiTiets,
    //     mucPhaiThuMienGiams,
    //     mucPhaiThuChiTietMienGiams
    // });

    useEffect(() => {
        handleReloadAllAsync();
    }, [props.sf_mucphaithu_id]);
    const handleReloadAllAsync = async () => {
        handleGetMucPhaiThuInfoAsync();
        handletGetMucPhaiThuChiTietAsync();
        handleGetMucPhaiThuHoanPhiAsync();
        handleGetMucPhaiThuMienGiamAsync();
        handleGetMucPhaiThuChiTietMienGiamAsync();
    };
    const handleGetMucPhaiThuInfoAsync = async () => {
        const res = await mucPhaiThuApi.selectById(props.sf_mucphaithu_id);
        if (res.is_success) {
            setMucPhaiThu(res.data);
        } else {
            showNotify({ message: "Không tải được chứng từ", type: 'error' });
        }
    };
    const handleGetMucPhaiThuMienGiamAsync = async () => {
        const res = await thuPhiApi.select_miengiam(props.sf_mucphaithu_id);
        if (res.is_success) {
            setMucPhaiThuMienGiams(res.data);
        } else {
            showNotify({ message: "Không tải được miễn giảm", type: 'error' });
        }
    };
    const handleGetMucPhaiThuChiTietMienGiamAsync = async () => {
        const res = await thuPhiApi.select_miengiam_chitiet(props.sf_mucphaithu_id);
        if (res.is_success) {
            setMucPhaiThuChiTietMienGiams(res.data);
        } else {
            showNotify({ message: "Không tải được miễn giảm", type: 'error' });
        }
    };
    const handleGetMucPhaiThuHoanPhiAsync = async () => {
        const res = await mucPhaiThuApi.selectByHoanPhiGoc(props.sf_mucphaithu_id);
        if (res.is_success) {
            setMucPhaiThuHoanPhis(res.data);
        } else {
            showNotify({ message: "Không tải được chứng từ", type: 'error' });
        }
    };
    const handletGetMucPhaiThuChiTietAsync = async () => {
        const res = await mucPhaiThuChiTietApi.selectByMucPhaiThu(props.sf_mucphaithu_id);
        if (res.is_success) {

            setMucPhaiThuChiTiets(
                res.data.map((x: any) => {
                    return {
                        ...x,
                        so_tien_hoan_phi: x.so_tien_phai_nop - x.so_tien_da_hoan_tra,
                    };
                })
            );
            setMucPhaiThuChiTietSelectedIds([]);
        } else {
            showNotify({ message: "Không tải được chứng từ", type: 'error' });
        }
    };
    const hanldeCreateHoanPhiAsync = async () => {
        if (
            window.confirm("Bạn có chắc chắn tạo hoàn phí cho các khoản nộp đã chọn")
        ) {
            setIsSaving(true);
            const dataSource: any = grid.current.instance.option("dataSource");

            const selectedItems = dataSource.filter((x: any) => {
                return mucPhaiThuChiTietSelectedIds.includes(x.id);
            });
            const totalAmount = hoanPhiSelectedMucPhaiThuChiTiets
                .map((x: any) => x.tong_hoan_tra)
                .reduce((a: any, b: any) => a + b, 0);
            if (totalAmount <= 0) {
                showNotify({ message: "Số tiền hoàn phí phải lớn hơn 0", type: 'error' });
                setIsSaving(false);

                return false;
            }
            // console.log({
            //     dataSource,
            //     mucPhaiThuChiTietSelectedIds,
            //     selectedItems,
            //     totalAmount
            // });
            if (noiDungHoanPhi === '') {
                setIsSaving(false);
                showNotify({ message: "Vui lòng nhập nội dung hoàn phí", type: 'error' });
                return;
            }
            if (hinhThucNopBomIds.length === 0) {
                setIsSaving(false);
                showNotify({ message: "Vui lòng chọn kỳ nộp áp dụng", type: 'error' });
                return;
            }
            const request: IMucPhaiThuHoanPhiRequest = {
                sf_mucphaithu_id: props.sf_mucphaithu_id,
                items: selectedItems.map((x: any) => {
                    return {
                        sf_mucphaithu_chitiet_id: x.id,
                        sf_khoannop_id: x.sf_khoannop_id,
                        so_tien_hoan_phi: x.so_tien_hoan_phi
                        // sf_mucphaithu_chitiet_id: number;
                        // sf_khoannop_id: number;
                        // so_tien_hoan_phi: number;
                    };
                }),
                mien_giams: hoanPhiSelectedMucPhaiThuChiTiets,
                ngay_thu: ngaythu,
                noi_dung_hoan_phi: noiDungHoanPhi,
                sf_hinhthucnopbom_ids: hinhThucNopBomIds.join(",")
            };

            const res = await mucPhaiThuApi.addHoanPhi(request);
            setIsSaving(false);
            if (res.is_success) {
                showNotify({ message: "Tạo hoàn phí thành công", type: 'success' });
                handleReloadAllAsync();
            } else {
                showNotify({ message: "Có lỗi", type: 'error' });
            }
        }
    };
    const DetailTemplate = (props: any) => {
        const mucPhaiThuChiTiet = props.data.data;
        const hoanPhiSelectedMucPhaiThuChiTiet: any =
            hoanPhiSelectedMucPhaiThuChiTiets.find(
                (x: any) => x.sf_mucphaithu_chitiet_id === props.data.data.id
            );
        const mienGiams = mucPhaiThuChiTietMienGiams.filter(
            (x: any) => x.sf_mucphaithu_chitiet_id === props.data.data.id
        );
        // console.log({
        //     props,
        //     data:props.data.data,
        //     hoanPhiSelectedMucPhaiThuChiTiet,
        //     hoanPhiSelectedMucPhaiThuChiTiets
        // });
        const tongHoanTra = (
            mucPhaiThuChiTiet: any,
            phan_tram: number,
            mienGiams: any[]
        ) => {
            const data = mienGiams
                .map((x) => x.so_tien_hoan)
                .reduce((a: any, b: any) => a + b, 0);
            // console.log({
            //     tongHoanTra: mienGiams,
            //     data,
            // });
            return (mucPhaiThuChiTiet.so_tien_phai_nop * phan_tram) / 100;
        };

        return (
            <div className={styles.detail}>
                <div className={styles.phanTram}>
                    <FormGroupInline label="Phần trăm" label_minwidth={400}>
                        <NumberBox
                            stylingMode="outlined"
                            value={
                                hoanPhiSelectedMucPhaiThuChiTiet
                                    ? hoanPhiSelectedMucPhaiThuChiTiet.phan_tram
                                    : 0
                            }
                            onValueChanged={(e) => {
                                if (e.event) {
                                    const tong_hoan_tra = tongHoanTra(
                                        props.data.data,
                                        e.value ?? 0,
                                        mienGiams.map((m: any) => {
                                            return {
                                                ...m,
                                                so_tien_hoan:
                                                    (m.so_tien_mien_giam * (e.value ?? 0)) / 100,
                                            };
                                        })
                                    );
                                    if (hoanPhiSelectedMucPhaiThuChiTiet) {
                                        setHoanPhiSelectedMucPhaiThuChiTiets([
                                            ...hoanPhiSelectedMucPhaiThuChiTiets.filter(
                                                (x: any) =>
                                                    x.sf_mucphaithu_chitiet_id != props.data.data.id
                                            ),
                                            {
                                                ...hoanPhiSelectedMucPhaiThuChiTiet,
                                                phan_tram: e.value,
                                                mienGiams: [
                                                    ...mienGiams.map((m: any) => {
                                                        return {
                                                            ...m,
                                                            so_tien_hoan:
                                                                (m.so_tien_mien_giam * (e.value ?? 0)) / 100,
                                                            // so_tien_hoan:(m.so_tien_mien_giam * (e.value??0)/100) / mucPhaiThuChiTiet.so_tien_mien_giam * mucPhaiThuChiTiet.so_tien_phai_nop
                                                        };
                                                    }),
                                                ],
                                                tong_hoan_tra: tong_hoan_tra,
                                            },
                                        ]);
                                    } else {
                                        setHoanPhiSelectedMucPhaiThuChiTiets([
                                            ...hoanPhiSelectedMucPhaiThuChiTiets,
                                            {
                                                sf_mucphaithu_chitiet_id: props.data.data.id,
                                                phan_tram: e.value,
                                                mienGiams: [
                                                    ...mienGiams.map((m: any) => {
                                                        return {
                                                            ...m,
                                                            // so_tien_hoan:(m.so_tien_mien_giam * (e.value??0)/100) / mucPhaiThuChiTiet.so_tien_mien_giam * mucPhaiThuChiTiet.so_tien_phai_nop

                                                            so_tien_hoan:
                                                                (m.so_tien_mien_giam * (e.value ?? 0)) / 100,
                                                        };
                                                    }),
                                                ],
                                                tong_hoan_tra: tong_hoan_tra,
                                            },
                                        ]);
                                    }
                                }
                            }}
                        />
                    </FormGroupInline>
                </div>

                <div className={styles.mienGiams}>
                    <p>Số tiền hoàn theo từng miễn giảm</p>
                    {mienGiams.map((m: any) => {
                        const mienGiamHoanPhi: any = hoanPhiSelectedMucPhaiThuChiTiet && hoanPhiSelectedMucPhaiThuChiTiet.mienGiams
                            ? hoanPhiSelectedMucPhaiThuChiTiet.mienGiams.find(
                                (y: any) => y.id == m.id
                            )
                            : undefined;
                        return (
                            <div className={styles.mienGiam} key={m.id}>
                                <FormGroupInline
                                    label_minwidth={400}
                                    label={
                                        m.hinh_thuc_mien_giam +
                                        `(Gốc: ${m.so_tien_mien_giam.toLocaleString()})`
                                    }
                                >
                                    <NumberBox
                                        stylingMode="outlined"
                                        format={"0,###"}
                                        value={mienGiamHoanPhi ? mienGiamHoanPhi.so_tien_hoan : 0}
                                    />
                                </FormGroupInline>
                            </div>
                        );
                    })}
                </div>

                <div className={styles.soTien}>
                    <FormGroupInline label="Tổng số tiền miễn giảm" label_minwidth={400}>
                        <NumberBox
                            stylingMode="outlined"
                            format={"0,###"}
                            value={
                                hoanPhiSelectedMucPhaiThuChiTiet && hoanPhiSelectedMucPhaiThuChiTiet.mienGiams
                                    ? hoanPhiSelectedMucPhaiThuChiTiet.mienGiams
                                        .map((x: any) => x.so_tien_hoan)
                                        .reduce((a: any, b: any) => a + b, 0)
                                    : 0
                            }
                            readOnly
                        />
                    </FormGroupInline>
                </div>

                <div className={styles.soTien}>
                    <FormGroupInline label="Tổng số tiền hoàn" label_minwidth={400}>
                        <NumberBox
                            stylingMode="outlined"
                            format={"0,###"}
                            value={
                                hoanPhiSelectedMucPhaiThuChiTiet
                                    ? hoanPhiSelectedMucPhaiThuChiTiet.tong_hoan_tra
                                    : 0
                            }
                            onValueChanged={(e) => {
                                if (e.event) {
                                    if (hoanPhiSelectedMucPhaiThuChiTiet) {
                                        setHoanPhiSelectedMucPhaiThuChiTiets([
                                            ...hoanPhiSelectedMucPhaiThuChiTiets.filter(
                                                (x: any) =>
                                                    x.sf_mucphaithu_chitiet_id !== props.data.data.id
                                            ),
                                            {
                                                ...hoanPhiSelectedMucPhaiThuChiTiet,

                                                tong_hoan_tra: e.value ?? 0,
                                            },
                                        ]);
                                    } else {
                                        setHoanPhiSelectedMucPhaiThuChiTiets([
                                            ...hoanPhiSelectedMucPhaiThuChiTiets,
                                            {
                                                sf_mucphaithu_chitiet_id: props.data.data.id,

                                                tong_hoan_tra: e.value ?? 0,
                                            },
                                        ]);
                                    }
                                }
                            }}
                        />
                    </FormGroupInline>
                </div>
                {/* <div className={styles.mienGiamActions}>
                <Button text='Add' type='success'
                onClick={()=>{
                    setHoanPhiSelectedMucPhaiThuChiTiets()
                }}
                />
               </div> */}
            </div>
        );
    };
    const handleUpdateSoTienTruyThu = async ({ sf_mucphaithu_chitiet_id, so_tien_truy_thu }: { sf_mucphaithu_chitiet_id: number; so_tien_truy_thu: number }) => {
        const datasend: { sf_mucphaithu_chitiet_id: number; so_tien_truy_thu: number } = { sf_mucphaithu_chitiet_id, so_tien_truy_thu };
        const res = await mucPhaiThuChiTietApi.UpdateSoTienTruyThu(datasend);
        if (res.is_success) {
            handleReloadAllAsync();
        } else {
        }
    };

    return (
        <DefaultPopup
            title="Hoàn phí học sinh"
            onClose={props.onClose}
        >
            <div className={styles.container}>
                {mucPhaiThu && (
                    <>
                        <div className={styles.header}>
                            Hoàn phí cho chứng từ số <b>{mucPhaiThu.so_chung_tu}</b>, học sinh{" "}
                            <b>{mucPhaiThu.ho_ten}</b> ( {mucPhaiThu.ma_hs} ) -{" "}
                            {mucPhaiThu.ten_khoi}
                        </div>
                        <div className={styles.mucPhiThuInfo}>
                            <DataGrid
                                dataSource={mucPhaiThuChiTiets}
                                keyExpr="id"
                                ref={grid}
                                showRowLines={true}
                                selectedRowKeys={mucPhaiThuChiTietSelectedIds}
                                onSelectionChanged={({ selectedRowKeys }) => {
                                    setMucPhaiThuChiTietSelectedIds(selectedRowKeys)
                                }}
                                paging={{
                                    enabled: false
                                }}
                            // selection={{
                            //     mode: "multiple",
                            //     selectedRowKeys: mucPhaiThuChiTietSelectedIds
                            // }}
                            >
                                <Editing mode={"cell"} allowAdding={false} allowDeleting={false} allowUpdating={true} />
                                <Selection mode={"multiple"} ></Selection>
                                <Column
                                    caption={"Nhóm"}
                                    dataField={"ten_khoan_nop_group"}
                                    allowEditing={false}
                                />
                                <Column
                                    caption={"Tên khoản nộp"}
                                    dataField={"ten_khoan_nop"}
                                    allowEditing={false}
                                />
                                <Column
                                    caption={"Định mức"}
                                    dataField={"so_tien_dinh_muc"}
                                    format={"0,###"}
                                    allowEditing={false}
                                />
                                <Column
                                    caption={"Miễn giảm"}
                                    dataField={"so_tien_mien_giam"}
                                    format={"0,###"}
                                    allowEditing={false}

                                />
                                <Column
                                    caption={"Truy thu"}
                                    dataField={"so_tien_truy_thu"}
                                    format={"0,###"}
                                    allowEditing={true}
                                    editCellRender={(cell: any) => {
                                        const so_tien_truy_thu = cell.data[`so_tien_truy_thu`];
                                        return (
                                            <NumberBox
                                                onValueChanged={(e) => {
                                                    if (e.event) {
                                                        handleUpdateSoTienTruyThu({
                                                            sf_mucphaithu_chitiet_id: cell.data.id,
                                                            so_tien_truy_thu: e.value || so_tien_truy_thu
                                                        });
                                                    }
                                                }}
                                                value={cell.data[`so_tien_truy_thu`]}
                                            />
                                        );
                                    }}
                                />
                                <Column
                                    caption={"Phải nộp"}
                                    dataField={"so_tien_phai_nop"}
                                    format={"0,###"}
                                    allowEditing={false}
                                />

                                <Column
                                    caption={"Đã hoàn phí"}
                                    dataField={"so_tien_da_hoan_tra"}
                                    format={"0,###"}
                                    allowEditing={false}
                                />
                                {/* <Column caption={"Số tiền hoàn phí"} dataField={"so_tien_hoan_phi"} format={"0,###"}
                                // editCellRender={(cell) => {
                                //     return <NumberBox format={"0,###"} />
                                // }}
                                setCellValue={(newData: any, value: any, currentRowData: any) => {
                                    newData.so_tien_hoan_phi = value;
                                    if (value != currentRowData.so_tien_phai_nop) {
                                        if (!mucPhaiThuChiTietSelectedIds.includes(currentRowData.id)) {
                                            setMucPhaiThuChiTietSelectedIds([...mucPhaiThuChiTietSelectedIds, currentRowData.id])
                                        }
                                    }
                                }} /> */}
                                <MasterDetail enabled={true} component={DetailTemplate} />
                            </DataGrid>
                        </div>
                        <div className="row">
                            <div className={styles.actions}>
                                <DateBox
                                    width={150}
                                    className={'margin-right-10'}
                                    value={ngaythu}
                                    onValueChange={(value) => {
                                        const newNgayThu = moment(value).format('YYYY-MM-DD');
                                        if (newNgayThu !== ngaythu) {
                                            set_ngaythu(newNgayThu);
                                        }
                                    }}
                                    displayFormat={'dd-MM-yyyy'} dateSerializationFormat={'yyyy-MM-dd'} labelMode={'static'} label={'Ngày thu thực tế'}
                                    readOnly={false}
                                />
                                <TextBox
                                    value={noiDungHoanPhi}
                                    className={'margin-right-10'}
                                    width={350}
                                    stylingMode="outlined"
                                    onValueChanged={(e) => {
                                        setNoiDungHoanPhi(e.value);
                                    }}
                                    placeholder="Nội dung"
                                />
                                <TagboxHinhThucNopBom
                                    width={'330px'}
                                    stylingMode="outlined"
                                    value={hinhThucNopBomIds}
                                    onValueChanged={(id: any, data: any) => {
                                        setHinhThucNopBomIds(id)
                                    }}
                                    dmCoSoId={1}
                                />
                                <Button
                                    text={`Tạo hoàn phí cho ${mucPhaiThuChiTietSelectedIds.length} khoản đã chọn`}
                                    isDisabled={mucPhaiThuChiTietSelectedIds.length === 0}
                                    icon="fas fa-chevron-down"
                                    isLoading={isSaving}
                                    onClick={() => {
                                        // debugger
                                        hanldeCreateHoanPhiAsync();
                                    }}
                                />
                            </div>
                        </div>
                        <div className={styles.hoanPhiCreated}>
                            {mucPhaiThuHoanPhis.length == 0 && (
                                <div className={styles.noData}>
                                    <p className={styles.caption}>
                                        Số chứng từ này chưa có dữ liệu hoàn phí
                                    </p>
                                    <p>
                                        Để làm hoàn phí Anh/chị vui lòng chọn các khoản muốn hoàn ở
                                        danh sách trên, điền số tiền hoàn phí (tại cột Số tiền hoàn
                                        phí)
                                    </p>
                                    <p>Sau đó nhấn Tạo hoàn phí</p>
                                </div>
                            )}
                            {mucPhaiThuHoanPhis.length > 0 && (
                                <div className={styles.hasData}>
                                    <p className={styles.caption}>
                                        Danh sách các số chứng từ hoàn phí đã tạo (
                                        {mucPhaiThuHoanPhis.length} chứng từ)
                                    </p>
                                </div>
                            )}
                            {mucPhaiThuHoanPhis.map((x) => {
                                return <HoanPhiDaTao sf_mucphaithu_id={x.id} sf_mucphaithu={x} />;
                            })}
                        </div>
                    </>
                )}
            </div>
        </DefaultPopup>
    );
};

export default HoanPhiHocSinhPage;
